import { createAction } from '@reduxjs/toolkit';
import { ReactNode, Context as ReactContext } from 'react';

import { useModal } from '@perpay-web/components/base/Modal/useModal';
import { useActionObservableCallback } from '@perpay-web/hooks/useActionObservableCallback';
import { hookAction$ } from '@perpay-web/services/singletons';
import { createContextProvider } from '@perpay-web/utils/componentUtils';

export const emailMisspelledModalSetIsModalOpen = createAction<boolean>(
    'EMAIL_MISSPELLED_MODAL::SET_IS_MODAL_OPEN',
);

type EmailMisspelledModalContextValue = {
    isModalOpen: boolean;
    setIsModalOpen: (value: boolean) => void;
};

const useEmailMisspelledModal = (): EmailMisspelledModalContextValue => {
    const { isModalOpen, setIsModalOpen } = useModal();

    return {
        isModalOpen,
        setIsModalOpen,
    };
};

const providerFactory = (
    Context: ReactContext<EmailMisspelledModalContextValue>,
) => {
    const Provider = ({ children }: { children: ReactNode }) => {
        const hook = useEmailMisspelledModal();

        useActionObservableCallback(
            hookAction$,
            emailMisspelledModalSetIsModalOpen.type,
            (value: boolean) => hook.setIsModalOpen(value),
        );

        return <Context.Provider value={hook}>{children}</Context.Provider>;
    };

    return Provider;
};

export const [EmailMisspelledModalProvider, useEmailMisspelledModalContext] =
    createContextProvider<EmailMisspelledModalContextValue>(providerFactory);
